module.exports = __webpack_public_path__ + "static/media/Template_13.4f3c1642.png";